import { fetchQuizCreatedOnHkDay } from "./quiz.store";

export async function checkIfAlreadyPlayedQuiz(): Promise<boolean> {
  const now = new Date();
  const quiz = await fetchQuizCreatedOnHkDay(now);
  return quiz !== null;
}
